import RepeatAutoFillGrid from "@/components/styled/div/RepeatAutoFillGrid";
import { Rem } from "@/types/common";

const HomeRepeatAutoFillGrid = ({
    itemMinWidth = "27rem",
    style,
    children,
    ...props
}: { itemMinWidth?: Rem } & React.HTMLAttributes<HTMLDivElement>) => {
    return (
        <RepeatAutoFillGrid itemMinWidth={itemMinWidth} style={{ gap: "2rem 2rem", ...style }} {...props}>
            {children}
        </RepeatAutoFillGrid>
    );
};

export default HomeRepeatAutoFillGrid;
